import { Tag } from 'components/ui';
import { ListingTypeEnum } from 'lib/api/generated';
import styled from 'styled-components';
import { globalTheme } from 'styles/global-theme';

const Pill = styled(Tag)`
  padding: ${globalTheme.space[1]} 14px;
  min-width: fit-content;
`;

interface ListingTypePillProps {
  type?: ListingTypeEnum;
}

/** Solid pill distinguishing a Wanted (BUY, pink) listing from a For Sale
 * (SELL, dark blue) one — used on the marketplace card and the detail view. */
export function ListingTypePill({ type }: ListingTypePillProps) {
  const isWanted = type === ListingTypeEnum.Buy;
  return (
    <Pill
      backgroundColor={isWanted ? 'pink' : 'darkBlue'}
      color='white'
      fontSize={2}
    >
      {isWanted ? 'Wanted' : 'For Sale'}
    </Pill>
  );
}

export default ListingTypePill;
